import { ForensicsSearchAlarms } from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useSearchForensics(tap?: (response: Response) => void) {
  const url = '/v2/orm/search';

  const request = new Request(url, {
    method: 'POST',
  });

  return useAuthenticatedMutation<ForensicsSearchAlarms[], FormData>(request, {
    getBody: (payload) => payload,

    responseModifier: async (response) => {
      if (tap) tap(response);
      const json = await response.json();
      return (json?.payload?.results || []) as ForensicsSearchAlarms[];
    },
  });
}

export default useSearchForensics;
